import axios from "axios";
import { del, get, post, put } from "./api_helper";
import * as url from "./url_helper";

/* -------------------- USER -------------------- */

const logUser = data => {
    return post(url.POST_LOGIN, data)
};

const getAllUsers = () => {
    return get(url.GET_USER);
};
const getAllCustomers = () => {
    return get(url.GET_USER_CUSTOMER);
};
const getUser = (id) => {
    return get(url.POST_USER+id);
};
const updateUser = (user) => {
    if(user && user.id) {
        return put(url.POST_USER+user.id, user);
    } else {
        return post(url.GET_USER, user);
    }
};
const updateUserPassword = (user) => {
    return put(url.UPDATE_PASSWORD+user.id, user);
};
const deleteUser = (uid) => {
    return del(url.POST_USER+uid);
};
const getCustomersKPI = () => {
    return get(url.GET_USER_KPI_CUSTOMER);
};
const getUsersKPI = () => {
    return get(url.GET_USER_KPI);
};
const setUserPrefs = (user) => {
    if(user && user.id) {
        return put(url.POST_USER_PREFS+user.id, {prefs: user.prefs});
    }
}
const setUserBan = (user) => {
    return put(url.POST_USER_BAN+user.id, {isBan: user.isBan});
}
const requestPasswordReset = (email) => {
  return get(url.NEW_PASSWORD + email);
};
const validatePasswordToken = (token) => {
  return get(url.VALID_NEW_PASSWORD + token);
};
const resetPasswordWithToken = (data) => {
  return post(url.UPDATE_PWD, data);
};
const registerUser = (userData) => {
  return post(url.REGISTER_USER, userData);
};
const activateAccount = (token) => {
  return get(url.ACTIVATE_ACCOUNT + token);
};
const verifyUser = (id) => {
  return put(url.VERIFY_USER + id, {});
};
const ActivateUser = (id) => {
  return put(url.ACTIVATE_USER + id, {});
};

const updateUserPref = (userId, prefs) => {
    if(userId && prefs) {
        return put(url.POST_USER_PREFS + userId, prefs);
    }
}

const resendActivationEmail = (email) => {
  return post(url.RESEND_EMAIL_ACTIVATION + email);
};

const sendEmailAdmin = (data) => {
  return post(url.SEND_EMAIL_ADMIN, data);
};
/*======================================================== */


/* -------------------- GROUPS -------------------- */

const getAllGroups = () => {
    return get(url.GET_GROUP);
};
const getGroup = (id) => {
    return get(url.POST_GROUP+id);
};
const updateGroup = (group) => {
    if(group && group.id) {
        return put(url.POST_GROUP+group.id, group);
    } else {
        return post(url.GET_GROUP, group);
    }
};

const deleteGroup = (uid) => {
    return del(url.POST_GROUP+uid);
};
const getGroupsKPI = () => {
    return get(url.GET_GROUP_KPI);
};
/*======================================================== */

/* -------------------- COMMENTS -------------------- */
const getAllComments = () => {
    return get(url.GET_COMMENT);
};
const getComment = (id) => {
    return get(url.POST_COMMENT+id);
};
const updateComment = (comment) => {
    if(comment && comment.id) {
        return put(url.POST_COMMENT+comment.id, comment);
    } else {
        return post(url.GET_COMMENT, comment);
    }
};
const deleteComment = (uid) => {
    return del(url.POST_COMMENT+uid);
};
/*======================================================== */

/* -------------------- PROJECTS -------------------- */

const getAllProjects = () => {
    return get(url.GET_PROJECTS);
};
const getProject = (id) => {
    return get(url.POST_PROJECT+id);
};
const updateProject = (project) => {
    if(project && project.id) {
        return put(url.POST_PROJECT+project.id, project);
    } else {
        return post(url.GET_PROJECTS, project);
    }
};
const deleteProject = (uid) => {
    return del(url.POST_PROJECT+uid);
};
/*======================================================== */


/* -------------------- PROJECTS -------------------- */

const getAllQuotes = () => {
    return get(url.GET_PROJECTS);
};
const getQuote = (id) => {
    return get(url.POST_PROJECT+id);
};
const updateQuote = (project) => {
    if(project && project.id) {
        return put(url.POST_PROJECT+project.id, project);
    } else {
        return post(url.GET_PROJECTS, project);
    }
};
const deleteQuote = (uid) => {
    return del(url.POST_PROJECT+uid);
};
/*======================================================== */

/* -------------------- PRODUCTS -------------------- */

const getAllProducts = () => {
    return get(url.GET_PRODUCTS);
};
const getProduct = (id) => {
    return get(url.POST_PRODUCT+id);
};
const updateProduct = (product, config) => {
    if(product && product.id) {
        return put(url.POST_PRODUCT+product.id, product, config);
    } else {
        return post(url.POST_PRODUCT, product, config);
    }
};
const deleteProduct = (uid) => {
    return del(url.POST_PRODUCT+uid);
};
/*======================================================== */

/* -------------------- UPLOAD -------------------- */

const uploadDocument = (document, entity, config) => {
    /* props structure:
       DATA, {type: 'default', params: 'entity'},  { "headers": { ... }})
       DATA, {type: 'default', params: 'entity'}
    */
    const { type, params} = entity

    if(document) {

        switch(type) { // switch to handle differents api urls
            case 'projProduct_updatePrice':
            return post(url.POST_PRICE_DOCUMENT + params, document, config);
            
            case undefined:
            case 'default':
            default:
            return post(url.POST_DOCUMENT + params, document, config);
        }
    }
};
/*======================================================== */

/* -------------------- BRANDS -------------------- */

const getAllBrands = () => {
    return get(url.GET_BRANDS);
};
const getBrand = (id) => {
    return get(url.POST_BRAND+id);
};
const updateBrand = (brand) => {
    if(brand && brand.id) {
        return put(url.POST_BRAND+brand.id, brand);
    } else {
        return post(url.GET_BRANDS, brand);
    }
};
const deleteBrand = (uid) => {
    return del(url.POST_BRAND+uid);
};
/*======================================================== */


/* -------------------- COMPONENTS -------------------- */

const getAllComponents = () => {
    return get(url.GET_COMPONENTS);
};
const getComponent = (id) => {
    return get(url.POST_COMPONENT+id);
};
const updateComponent = (component) => {
    if(component && component.id) {
        return put(url.POST_COMPONENT+component.id, component);
    } else {
        return post(url.GET_COMPONENTS, component);
    }
};
const deleteComponent = (uid) => {
    return del(url.POST_COMPONENT+uid);
};
/*======================================================== */

/* -------------------- CATEGORY -------------------- */
const getAllCategories = () => {
    return get(url.GET_CATEGORIES);
};
const getCategory = (id) => {
    return get(url.GET_CATEGORIES+id);
};
const updateCategory = (category) => {
    if(category && category.id) {
        return put(url.POST_CATEGORY+category.id, category);
    } else {
        return post(url.GET_CATEGORIES, category);
    }
};
const deleteCategory = (uid) => {
    return del(url.POST_PRODUCT+uid);
};
/*======================================================== */

/* -------------------- CONFIGURATION -------------------- */

//CONFIGURATION
const getAllConfigurations = () => {
    return get(url.GET_CONFIGURATIONS);
};
const getConfiguration = (id) => {
    return get(url.POST_CONFIGURATION+id);
};
const updateConfiguration = (configuration) => {
    if(configuration && configuration.id) {
        return put(url.POST_CONFIGURATION+configuration.id, configuration);
    } else {
        return post(url.GET_CONFIGURATIONS, configuration);
    }
};
const deleteConfiguration = (uid) => {
    return del(url.POST_CONFIGURATION+uid);
};

const duplicateConfiguration = (id, configDuplicate) => {
    return post(url.DUPLICATE_CONFIGURATION+id, configDuplicate);
};

const checkConfiguration = (id, config) => {
    return put(url.CHECK_CONFIGURATION+id, config);
};

const verifyConfiguration = (id, config) => {
    return post(url.VERIFY_CONFIGURATION+id, config);
};

const checkExpiredConfig = (days) => {
    return put(url.CHECK_CONFIGURATIONS_EXPIRED+days);
};

const createQuote = (id) => {
    return get(url.CREATE_QUOTE+id);
};

const quoteToPdf = (quoteData) => {
    return post(url.QUOTE_TO_PDF, quoteData);
};

/*======================================================== */

/* -------------------- SECTORS -------------------- */
const getAllSectors = () => {
    return get(url.GET_SECTOR);
};
const getSector = (id) => {
    return get(url.POST_SECTOR+id);
};
const updateSector = (sector) => {
    if(sector && sector.id) {
        return put(url.POST_SECTOR+sector.id, sector);
    } else {
        return post(url.GET_SECTOR, sector);
    }
};
const deleteSector = (uid) => {
    return del(url.POST_SECTOR+uid);
};

/*======================================================== */

/* -------------------- AGENCIES -------------------- */
const getAllAgencies = () => {
    return get(url.GET_AGENCIES);
};
const getAgency = (id) => {
    return get(url.POST_AGENCY+id);
};
const updateAgency = (agency) => {
    if(agency && agency.id) {
        return put(url.POST_AGENCY+agency.id, agency);
    } else {
        return post(url.GET_AGENCIES, agency);
    }
};
const deleteAgency = (uid) => {
    return del(url.POST_AGENCY+uid);
};

/*======================================================== */

/* -------------------- DEPARTMENTS -------------------- */
const getAllDepartments = () => {
    return get(url.POST_DEPARTMENT);
};
const getDepartment = (id) => {
    return get(url.POST_DEPARTMENT+id);
};
const updateDepartment = (department) => {
    if(department && department.id) {
        return put(url.POST_DEPARTMENT+department.id, department);
    } else {
        return post(url.POST_DEPARTMENT, department);
    }
};
const deleteDepartment = (uid) => {
    return del(url.POST_DEPARTMENT+uid);
};

/*======================================================== */

/* -------------------- LINES -------------------- */
const getAllLines = () => {
    return get(url.GET_LINES);
};
const getLine = (id) => {
    return get(url.POST_LINE+id);
};
const updateLine = (line) => {
    if(line && line.id) {
        return put(url.POST_LINE+line.id, line);
    } else {
        return post(url.GET_LINES, line);
    }
};
const deleteLine = (uid) => {
    return del(url.POST_LINE+uid);
};

/*======================================================== */

/* -------------------- DASHBOARD -------------------- */
const getDashboard = () => {
    return get(url.GET_DASHBOARD);
};
/*======================================================== */

/* -------------------- RELEASE -------------------- */

const getAllReleases = () => {
    return get(url.GET_RELEASE);
};
const getRelease = (id) => {
    return get(url.POST_RELEASE+id);
};
const updateRelease = (releaseNote) => {
    if(releaseNote && releaseNote.id) {
        return put(url.POST_RELEASE+releaseNote.id, releaseNote);
    } else {
        return post(url.GET_RELEASE, releaseNote);
    }
};
const deleteRelease = (uid) => {
    return del(url.POST_RELEASE+uid);
};
/*======================================================== */

/* -------------------- RELEASE NOTES -------------------- */
const getAllReleaseNotes = () => {
    return get(url.GET_RELEASE_NOTES);
};
const getReleaseNote = (id) => {
    return get(url.POST_RELEASE_NOTES+id);
};
const updateReleaseNote = (release) => {
    if(release && release.id) {
        return put(url.POST_RELEASE_NOTES+release.id, release);
    } else {
        return post(url.GET_RELEASE_NOTES, release);
    }
};
const deleteReleaseNote = (uid) => {
    return del(url.POST_RELEASE_NOTES+uid);
};
/*======================================================== */


/* -------------------- NOTIFICATIONS -------------------- */
const getAllNotifications = () => {
    return get(url.GET_NOTIFICATIONS);
};
const getAllNotificationsRelease = () => {
    return get(url.GET_NOTIFICATIONS_RELEASE);
};
const getNotification = (id) => {
    return get(url.POST_NOTIFICATIONS+id);
};
const updateNotification = (notification) => {
    if(notification && notification.id) {
        return put(url.POST_NOTIFICATIONS+notification.id, notification);
    } else {
        return post(url.GET_NOTIFICATIONS, notification);
    }
};
const deleteNotification = (uid) => {
    return del(url.POST_NOTIFICATIONS+uid);
};
/*======================================================== */


export {
    logUser,
    getAllUsers,
    getAllCustomers,
    getUser,
    updateUser,
    updateUserPassword,
    deleteUser,

    setUserBan,
    requestPasswordReset,
    validatePasswordToken,
    resetPasswordWithToken,
    registerUser,
    activateAccount,
    verifyUser,
    ActivateUser,

    setUserPrefs,
    getCustomersKPI,
    getUsersKPI,

    getAllGroups,
    getGroup,
    updateGroup,
    deleteGroup,
    getGroupsKPI,
    
    getAllComments,
    getComment,
    updateComment,
    deleteComment,
    
    getAllProjects,
    getProject,
    updateProject,
    deleteProject,
    
    getAllQuotes,
    getQuote,
    updateQuote,
    deleteQuote,
    
    getAllProducts,
    getProduct,
    updateProduct,
    deleteProduct,
    
    getAllBrands,
    getBrand,
    updateBrand,
    deleteBrand,

    getAllComponents,
    getComponent,
    updateComponent,
    deleteComponent,

    getAllCategories,
    getCategory,
    updateCategory,
    deleteCategory,

    getAllConfigurations,
    getConfiguration,
    updateConfiguration,
    deleteConfiguration,
    duplicateConfiguration,
    checkConfiguration,
    verifyConfiguration,
    checkExpiredConfig,
    createQuote,
    quoteToPdf,

    getAllSectors,
    getSector,
    updateSector,
    deleteSector,

    getAllAgencies,
    getAgency,
    updateAgency,
    deleteAgency,

    getAllDepartments,
    getDepartment,
    updateDepartment,
    deleteDepartment,

    getAllLines,
    getLine,
    updateLine,
    deleteLine,

    getDashboard,

    getAllReleases,
    getRelease,
    updateRelease,
    deleteRelease,
    getAllReleaseNotes,
    getReleaseNote,
    updateReleaseNote,
    deleteReleaseNote,

    getAllNotifications,
    getAllNotificationsRelease,
    getNotification,
    updateNotification,
    deleteNotification,

    uploadDocument,
    updateUserPref,
    resendActivationEmail,
    sendEmailAdmin
};